<template>
    <div class="pay-success-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/vip' }">开通VIP</el-breadcrumb-item>
            <el-breadcrumb-item>支付结果查询</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="pay-success-content" v-if="is_pay == 1">
            <el-row>
                <el-col :span="2">
                    <img src="../../assets/images/pay_success.png" alt="支付成功" class="pay-success-img">
                </el-col>
                <el-col :span="22">
                    <el-row class="pay-infor-title">支付成功</el-row>
                    <el-row class="pay-infor-desc pay-infor-desc-diff1">快去体验{{ website.name ? website.name : '荔枝生涯' }}丰富功能吧！</el-row>
                    <el-row class="pay-infor-desc pay-infor-desc-diff2">在线支付：¥{{wechatPay.fee}}</el-row>
                    <el-row class="pay-infor-desc">订单号：{{wechatPay.order_no}}</el-row>
                </el-col>
            </el-row>
            <el-row class="pay-infor-line"></el-row>
            <el-row class="buy-success-btn">
                <el-col :span="4">
                    <el-button class="buy-success-btn1" @click="backToHome">返回首页</el-button>
                </el-col>
                <el-col :span="4">
                    <el-button class="buy-success-btn2" @click="backToOrderDetail">订单详情</el-button>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="pay-fail-content" v-else-if="is_pay == 0">
            <el-row>
                <el-col :span="2">
                    <img src="../../assets/images/pay_fail.png" alt="支付成功" class="pay-fail-img">
                </el-col>
                <el-col :span="22">
                    <el-row class="pay-infor-title">支付失败</el-row>
                    <el-row class="pay-infor-desc">网络出错，请尝试重新支付！</el-row>
                </el-col>
            </el-row>
            <el-row class="pay-infor-line"></el-row>
            <el-row class="buy-fail-btn">
                <el-col :span="4">
                    <el-button class="buy-fail-btn1" @click="payVipHandler">重新支付</el-button>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="pay-result" v-else-if="is_pay == 2">
            <div class="pay-second">
                {{result_second}}
            </div>
            <div class="pay-result-desc">
                <img src="../../assets/images/result.gif">
                正在查询支付结果，请耐心等待！
            </div>
        </el-row>
    </div>
</template>

<script>
import { isPay, againPay } from '@/api/pay'
import { checkVip } from '@/api/vip'
import { mapState } from "vuex"
export default {
    data () {
        return {
            result_second: 3,
            timer: null,
            order_no: '',
            is_pay: 2,
        }
    },
    computed: {
        ...mapState({
            wechatPay: state => state.user.qr_code,
            isWechatPay: state => state.user.isWechatPay,
            website: state => state.user.website
        }),
    },
    watch: {
        isWechatPay(newVal) {
            if(!newVal) {
                this.is_pay = '2'
                this.result_second = 3
                this.setTime()
            }
        }  
    },
    created () {
        this.setTime();
    },
    methods: {
        setTime() {
            let that = this;
            let result_second = 3
            this.order_no = this.wechatPay.order_no
            that.timer = setInterval(() => {
                if(that.result_second == 1) {
                    clearInterval(that.timer)
                    that.timer = null;
                    that.orderDetailHandler()
                } else if(that.result_second > 1) { 
                    result_second = result_second - 1
                    that.result_second = result_second
                }
            },1000)
        },
        backToHome() {
            this.$router.push({
                path: '/home'
            })
        },
        backToOrderDetail() {
            this.$router.push({
                name: 'order-detail',
                params: {
                    order_no: this.order_no
                }
            })
        },
        payVipHandler() {
            againPay(this.order_no).then(res => {
                this.$set(this.wechatPay,'qr_code',res.data.qr_code)
                this.$store.commit('user/QRCODE',this.wechatPay)
                this.$store.commit('user/SHOWWECHAT', true)
            })
        },
        orderDetailHandler() {
            isPay(this.order_no).then(res => {
                this.is_pay = res.data.is_pay
                this.checkVipHandler()
            })
        },
        checkVipHandler() {
            checkVip().then(res => {
                this.$store.commit('user/VIPTYPESTATUS',res.data.has_code);
                const function_code = res.data.function_code
                this.$store.commit('user/FUNCTIONCODE',function_code);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .pay-success-box {
        .pay-success-content {
            @include gwidth;
            height: 365px;
            background: #ffffff;
            border-radius: 10px;
            box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10);
            margin-top: 24px;
            padding: 40px;
            box-sizing: border-box;
            .pay-success-img {
                width: 80px;
                height: 80px;
            }
            .el-col-22 {
                padding-left: 16px;
            }
            .pay-infor-title {
                font-size: 28px;
                font-weight: 600;
                color: #2c2e33;
            }
            .pay-infor-desc {
                font-size: 18px;
                color: #5e6166; 
                font-weight: 400;
            }
            .pay-infor-desc-diff1 {
                margin-top: 24px;
                margin-bottom: 28px;
            }
            .pay-infor-desc-diff2 {
                margin-bottom: 12px;
            }
            .pay-infor-line {
                border-bottom: 1px solid #f0f2f5;
                margin-top: 40px;
                margin-bottom: 32px;
            }
            .buy-success-btn {
                padding-left: calc(8.33333% + 16px); 
            }
            .buy-success-btn1 {
                width: 152px;
                height: 52px;
                background: #ffffff;
                border: 1px solid $common-color;
                border-radius: 8px;
                font-weight: 600;
                font-size: 18px;
                color: $common-color;
                font-weight: 600!important;
            }
            .buy-success-btn2 {
                width: 152px;
                height: 52px;
                border: 1px solid #c4c7cc;
                border-radius: 8px;
                color: #5e6166;
                font-size: 18px;
                font-weight: 600!important;
                margin-left: 16px;
            }
        }
        .pay-fail-content {
            @include gwidth;
            height: 285px;
            background: #ffffff;
            border-radius: 10px;
            box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10);
            margin-top: 24px;
            padding: 40px;
            box-sizing: border-box;
            .pay-fail-img {
                width: 80px;
                height: 80px;
            }
            .el-col-22 {
                padding-left: 16px;
            }
            .pay-infor-title {
                font-size: 28px;
                font-weight: 600;
                color: #2c2e33;
            }
            .pay-infor-desc {
                font-size: 18px;
                color: #5e6166; 
                font-weight: 400;
                margin-top: 24px;
            }
            .pay-infor-line {
                border-bottom: 1px solid #f0f2f5;
                margin-top: 36px;
                margin-bottom: 32px;
            }
            .buy-fail-btn {
                padding-left: calc(8.33333% + 16px); 
            }
            .buy-fail-btn1 {
                width: 152px;
                height: 52px;
                background: #ffffff;
                border: 1px solid $common-color;
                border-radius: 8px;
                font-weight: 600;
                font-size: 18px;
                color: $common-color;
            }
            .buy-fail-btn2 {
                width: 152px;
                height: 52px;
                border: 1px solid #c4c7cc;
                border-radius: 8px;
                color: #5e6166;
                font-size: 18px;
                font-weight: 600;
                margin-left: 16px;
            }
        }
        .pay-result {
            @include gwidth;
            height: 365px;
            background: #ffffff;
            border-radius: 10px;
            box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10);
            margin-top: 24px;
            padding: 72px 0px 79px 0;
            box-sizing: border-box;
            text-align: center;
            .pay-second {
                width: 136px;
                height: 136px;
                background: #3272ff;
                border-radius: 50%;
                color: #ffffff;
                font-weight: 500;
                font-size: 48px;
                margin: 0 auto;
                line-height: 136px;
            }
            .pay-result-desc {
                margin-top: 50px;
                color: #2c2e33;
                font-size: 16px;
                font-weight: 400;
                img {
                    position: relative;
                    top: 7px;
                }
            }
        }
    }
</style>